<template>
  <Information v-if="originMeta.length" class="relative top-0.5 ml-1 inline-flex text-gray-400">
    <template #trigger>
      <InformationCircleIcon class="h-4 w-4 hover:text-gray-500" />
    </template>
    <template #modal>
      <div class="space-y-2 text-left">
        <div class="text-xs font-medium uppercase tracking-wide text-gray-400">
          {{ t('origin') }}
        </div>
        <div v-for="(item, index) in originMeta" :key="index">
          <div class="font-medium">{{ t(`originTypes.${item.originType}`) }}</div>
          <div class="font-mono text-xs text-gray-600">
            {{ item.providerName }}.{{ item.handlerName }}
          </div>
          <div v-if="item.jobId" class="text-xs text-gray-500">
            {{ t('jobId') }}:
            <span class="font-mono">{{ item.jobId }}</span>
          </div>
        </div>
      </div>
    </template>
  </Information>
</template>

<script setup lang="ts">
import Information from '@/components/Information.vue';
import type { AuditLog, OriginMeta } from '@carvia/ros-client-types';
import { InformationCircleIcon } from '@heroicons/vue/24/outline';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  meta?: AuditLog['meta'];
}>();

const { t } = useI18n();

const originMeta = computed(
  () => props.meta?.filter((item): item is OriginMeta => item?.type === 'origin') ?? [],
);
</script>

<i18n lang="json">
{
  "en": {
    "origin": "Origin",
    "jobId": "Job ID",
    "originTypes": {
      "controller": "Controller",
      "queue": "Queue"
    }
  },
  "de": {
    "origin": "Ursprung",
    "jobId": "Job-ID",
    "originTypes": {
      "controller": "Controller",
      "queue": "Queue"
    }
  }
}
</i18n>
